function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Chevron Left"));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "iconic-size-md-chevron-clip-0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h26v32h-26z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  "data-width": 30,
  "data-height": 32,
  className: "iconic-container",
  transform: " translate(1 0)"
}, /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#iconic-size-md-chevron-clip-0)",
  stroke: "#000",
  strokeWidth: 6,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  className: "iconic-property-stroke",
  d: "M-1-6l22 22-22 22",
  fill: "none",
  transform: "rotate(180 16 16 ) translate(2)"
}));

function SvgChevronLeftMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-icon": "chevron-left",
    width: 32,
    height: 32,
    className: "iconic iconic-chevron iconic-size-md iconic-chevron-left",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftMd);
export default __webpack_public_path__ + "static/media/chevron-left-md.431f0d5d.svg";
export { ForwardRef as ReactComponent };